<template>
	<div class="solution">
		<div class="img">
			<img :src="banner"/>
		</div>
		<!--路径-->
		<div class="container">
			<div class="path">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  	<el-breadcrumb-item>解决方案</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			
			<!--内容-->
			<div class="content">
				<div class="swiper-container">
				    <div class="swiper-wrapper">
						<div class="swiper-slide" :class="item.id==0?'active':''" :id="'main'+item.id" v-for="item in navlist" @click="getData(item.id)">{{item.name}}</div>
				    </div>
				</div>
				<div class="mainBox">
					<ul v-if="mainList">
						<li 
							v-for="main in mainList" 
							@click="gotoDetail(main.id)">
							<img :src="main.pic"/>
							<p>{{main.title}}</p>
						</li>
					</ul>
					<div class="nomore" v-if="mainList.length == 0">
						<i class="el-icon-refresh"></i>暂时没有更多信息显示
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from "swiper";
	import "swiper/dist/css/swiper.min.css";
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'solution',
				navlist: [],
				mainList:[],
				sel:'',
				banner:'',
			}
		},
		methods:{
			getItem(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.solutionGetListApi,
					data: {}
				})
				.then((res) => {
					this.navlist = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getData(id){
				this.axios({
					method: 'get',
					url: this.GLOBAL.solutionGetDataApi+id,
					data: {}
				})
				.then((res) => {
					this.mainList = res.data.data;
					$('.swiper-slide').removeClass('active');
					$("#main"+id).addClass('active');
					console.log(3)
				})
				.catch((err) => {
					console.log(err)
				})
			},
			gotoDetail(id){
				this.$router.push({
							path:'/soluDetail',
							query: {
				          		id:id,
				          	}
				        })
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'4',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner4;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getItemId(){
				var id = this.$route.params.id;
				console.log(id);
				if(id){
					this.getData(id);
					console.log(1)
				}else{
					this.getData(0);
					console.log(2)
				}
			}
		},
 		created(){
			this.getItem();
			this.getBanner();
			this.getItemId();
 		},
		mounted(){
			var mySwiper = new Swiper('.swiper-container', {
				spaceBetween: 10,
				slidesPerGroup: 3,
				slidesPerView: 3,
				loop: false,
				loopFillGroupWithBlank: true,
				observer:true,//修改swiper自己或子元素时，自动初始化swiper 
				observeParents:false,//修改swiper的父元素时，自动初始化swiper 
				initialSlide:0,
				onSlideChangeEnd: function(swiper){ 
					swiper.update(); 
				}
		    });
		    setTimeout(function(){
		    	$('.swiper-wrapper').css('transform','translate3d(0px, 0px, 0px)')
		    },500)

 		}
	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.solution{
	.img{
		width:100%;
		overflow:hidden;
		position:relative;
		.height(300);
		img{
			width: 150%;
			height: 100%;
			position:absolute;
			left:-20%;
		}
	}
	.container{
		.padding-left(20);
		.padding-right(20);
		.path{
			.margin-top(20);
			.margin-bottom(20);
			span{
				color: #00A0FF;
			}
		}
		.content{
			.margin-top(70);
			.mainBox{
				ul{
					display: flex;
					flex-wrap: wrap;
					justify-content: flex-start;
					.margin-top(20);
					li{
						border-radius:5px;
						overflow:hidden;
						cursor:pointer;
						.margin-bottom(25);
						img{
							width:100%;
							display:block;
						}
						p{
							.padding(20,20,20,20);
							background:#00A0FF;
							color:#fff;
						}
					}
				}
			}
			.nomore{
				font-size: 20px;
				text-align: center;
				margin-top: 50px;
				margin-bottom: 30px;
			}
		}
	
	}
	.swiper-button-next,.swiper-button-prev{
		background-size: 10px;
	}
	.swiper-slide{
		.font-size(30);
		.padding(10,20,10,20);
		text-align:center;
		background-color:#eee;
	}
	.active{
		background:#229dfe !important;
		color:#fff;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Solution/Solution.vue